/**
 * Coral clients need a framework-agnostic request class that can be easily
 * copied (to support e.g. serialization, auth, etc.)
 *
 * The spec-compliant Request class falls short, as there is no easy way to copy
 * it -- in particular, the body can only be read once and is only available
 * asynchronously.
 *
 * The CoralRequest can also simplify some constituent types (e.g. headers), while
 * also ensuring certain default values (POST method, include credentials).
 */
export class CoralRequest {
    constructor(init) {
        Object.assign(this, init);
        // explicit assignment avoids compiler warning that readonly properties
        // are not definitely set in the constructor.
        this.config = init.config;
        this.credentials = init.credentials || 'include';
        this.headers = init.headers;
        this.operation = init.operation;
        this.method = init.method || 'POST';
        this.serviceName = init.serviceName;
        this.url = init.url;
    }
    /**
     * Clone the request with one or more updated properties.
     *
     * By default, `signal` will not be shared with the cloned request -- if that
     * behavior is desirable, do `request.clone({signal: request.signal})`
     */
    clone(update) {
        // by default, do not share signals between requests.
        return new CoralRequest(Object.assign(Object.assign(Object.assign({}, this), { signal: null }), update));
    }
    /**
     * Convert to a native HTML-spec-compliant Request instance.
     */
    toNativeRequest() {
        return new Request(this.url, Object.assign({}, this));
    }
}
